"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var FilmFillEdit = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_FilmFillEdit_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.218 1.092C0 1.52 0 2.08 0 3.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C1.52 14 2.08 14 3.2 14h4.008l.091-.641c.049-.341.207-.658.451-.902l4.99-4.99.01-.01V6.25a.5.5 0 0 1 .5-.5H14a.5.5 0 0 1 .5.5v.88c.18.078.348.19.495.337L16 8.472V3.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 0 13.92 0 12.8 0H3.2C2.08 0 1.52 0 1.092.218a2 2 0 0 0-.874.874ZM2 10a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 .5.5h.75a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 0-.5-.5H2Zm0-8.5a.5.5 0 0 0-.5.5v1.5A.5.5 0 0 0 2 4h.75a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5H2Zm10.75.5a.5.5 0 0 1 .5-.5H14a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5h-.75a.5.5 0 0 1-.5-.5V2ZM2 5.75a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5h.75a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 0-.5-.5H2Zm3.5-1.1v4.7c0 .496.537.809.97.566l4.198-2.35a.647.647 0 0 0 0-1.131L6.47 4.085a.651.651 0 0 0-.971.565Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.826 9.712-1.538-1.538a.595.595 0 0 0-.841 0l-.783.783 2.379 2.379.783-.783a.595.595 0 0 0 0-.841ZM8.457 13.164l3.5-3.5 2.379 2.379-3.5 3.5a.595.595 0 0 1-.337.168l-1.99.284a.446.446 0 0 1-.504-.504l.284-1.99a.594.594 0 0 1 .168-.337Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_FilmFillEdit_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = FilmFillEdit;
exports["default"] = _default;